import { get } from 'utils/api';

export const fetchDashboardData = async () => {
  return get('/dashboard/');
};

export const dashboardApi = {
  fetchDashboardData,
};
